module.exports = __webpack_public_path__ + "static/media/infosection1.b6c963cd.jpeg";